import React, { InputHTMLAttributes, useState } from 'react'
import styled from '@emotion/styled'
import { useFormContext } from 'react-hook-form'
import { uniqueId } from 'lodash'

import { compressImage } from '@src/utils/image'

import SVGLoader from '@src/components/svg/SVGLoader'

const ThumbnailForm = () => {
	const { register } = useFormContext()

	const [fileList, setFileList] = useState<File[]>([])

	const handleChangeImage = async (evt: React.ChangeEvent<HTMLInputElement>) => {
		const compressImages = []
		const { files } = evt.target
		if (files) {
			for (const file of files) {
				const compressedImg = compressImage(file)
				compressImages.push(compressedImg)
			}

			const thumbnailImg = await Promise.all(compressImages)
			setFileList((prevImgs) => [...prevImgs, ...thumbnailImg])
		}
	}

	return (
		<ImageList>
			<ImageItem>
				<Label htmlFor="thumbnailImage">
					<SVGLoader name="plus" />
				</Label>
				<InputStyle
					{...register('bannerFile', { onChange: handleChangeImage })}
					type="file"
					id="thumbnailImage"
					multiple
				/>
			</ImageItem>
			{fileList.map((thumbImg) => (
				<ImageItem key={uniqueId('thumbnail-')}>
					<Image src={URL.createObjectURL(thumbImg)} alt="asdasd" />
				</ImageItem>
			))}
		</ImageList>
	)
}

const ImageList = styled.ul`
	display: grid;
	grid-template-columns: repeat(5, minmax(7.6rem, 1fr));
	grid-auto-rows: minmax(7.6rem, auto);
	gap: 0.8rem 0.7rem;
	border-radius: 0.8rem;
	margin: 0px;
	margin-block: 0px;
	padding-inline-start: 0px;
	padding-left: 0px;
	list-style: none;
`

const ImageItem = styled.li`
	width: 15rem;
	height: 15rem;
	display: flex;
	-webkit-box-align: center;
	align-items: center;
	-webkit-box-pack: center;
	justify-content: center;
	background-color: rgb(242, 244, 246);
	border-radius: inherit;
	aspect-ratio: 1 / 1;
	overflow: hidden;
	position: relative;
	-webkit-tap-highlight-color: rgba(0, 0, 0, 0.1);
`

const Label = styled.label`
	margin: 0px;
	line-height: 1;
	cursor: inherit;
	display: flex;
	-webkit-box-align: inherit;
	align-items: inherit;
	-webkit-box-pack: inherit;
	justify-content: inherit;
	width: 100%;
	height: 100%;
	cursor: pointer;
`

const InputStyle = styled.input`
	position: absolute;
	width: 0.1rem;
	height: 0.1rem;
	bottom: 0;
	outline: none;
`

const Image = styled.img`
	width: 100%;
	height: 100%;
	object-fit: contain;
`

export default ThumbnailForm
